import { cn } from "@/utils/utils";
import { FullPageLoader } from "@common/components/Loading/FullPageLoading";

type Props = {
  className?: string;
};

export const Loading = ({ className }: Props) => {
  return (
    <div className={cn("h-full w-full", className)}>
      <FullPageLoader />
    </div>
  );
};
